import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { environment } from 'src/environments/environment';
import { GetPatientByCpfResponse } from '../../responses/medical-record/get-patient-by-cpf.response';
import { GetHealthUnitResponse } from '../../responses/user/client-health-unit.response';

@Injectable({
  providedIn: 'root'
})
export class HealthUnitService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient,) {
    super();
  }

  public getHealthUnit(idHealthUnit: number): Observable<GetHealthUnitResponse> {
    let uri = `ClientHealthUnit/idHealthUnit/${idHealthUnit}`
    return this.httpClient.get<GetHealthUnitResponse>(environment.urlApiUser + uri, this.addHeaderHash())
      .pipe(
        catchError(this.handleError)
      )
  }
}
